import React from 'react';
interface LogoProps {
  variant?: 'wordmark' | 'mark';
  className?: string;
}

/**
 * NICOLE brand marks.
 * - wordmark: typographic logotype, wide-tracked Montserrat ExtraBold.
 * - mark: secondary square icon with the letter N.
 */
export function Logo({
  variant = 'wordmark',
  className = ''
}: LogoProps) {
  if (variant === 'mark') {
    return <span aria-hidden="true" className={`inline-flex shrink-0 items-center justify-center rounded-[22%] bg-white font-display font-black leading-none text-night ${className}`} data-id="element-214" data-mp="3v6la7ihdmlhp">
        N
      </span>;
  }
  return <span className={`inline-flex items-center font-display font-extrabold uppercase leading-none text-white ${className}`} data-id="element-215" data-mp="dsxwzrldcecy">
      <span className="tracking-[0.32em] [margin-right:-0.32em]" data-id="element-216" data-mp="hrycb04n0yv7">NICOLE</span>
    </span>;
}